import apiConfig from '@constants/apiConfig';

import InwenChildSavePage from './inwenChild/InwenChildSavePage';
import InwenChildListPage from './inwenChild';
import InwenSavePage from './InwenSavePage';
import InwenListPage from '.';

export default {
    inwenListPage: {
        path: '/inwen',
        title: 'Inwen',
        auth: true,
        component: InwenListPage,
        permission: [ apiConfig.inwen.getList.baseURL ],
    },
    inwenSavePage: {
        path: '/inwen/:id',
        title: 'Inwen Save Page',
        auth: true,
        component: InwenSavePage,
        separateCheck: true,
        permission: [ apiConfig.inwen.create.baseURL, apiConfig.inwen.update.baseURL ],
    },
    inwenChildListPage: {
        path: '/inwen/inwen-child',
        title: 'Inwen',
        auth: true,
        component: InwenChildListPage,
        permission: [ apiConfig.inwen.getList.baseURL ],
    },
    inwenChildSavePage: {
        path: '/inwen/inwen-child/:id',
        title: 'Inwen Save Page',
        auth: true,
        component: InwenChildSavePage,
        separateCheck: true,
        permission: [ apiConfig.inwen.create.baseURL, apiConfig.inwen.update.baseURL ],
    },
};
